import React, {Component} from 'react';
import {
  Col,
  Checkbox
} from 'react-bootstrap';
class TabItem extends Component {
  render() {
    let {
      data,
      toggleCheckbox
    } = this.props;

    const isUndefined = (obj) => typeof obj === 'undefined'
      ? true
      : false;

    const getCheckbox = (obj, index) => {
      let name = obj.action,
          state = obj.access;
      return (
        <Checkbox checked={state} key={index} onChange={(e) => toggleCheckbox(data.module, index, obj)}>{name}</Checkbox>
      );
    }

    return (
      <Col md={12}>
        {
          isUndefined(data.actions)
          ? <div>NO DATA</div>
          : data.actions.map(getCheckbox)
        }
      </Col>
    );
  }
}

export default TabItem;



// WEBPACK FOOTER //
// ./components/AccessRight/TabItem.js